/**
 * 混合合约的委托类型
 * 注意：该值可能由页面交互元素合并而来
 */
import { BusinessLineEnum, BusinessSource, EnterPointSource } from './base'
import { OrderPriceTypeEnum, OrderTriggerTypeEnum } from './order'
import { PositionModeEnum } from 'constants/vars'

export enum MixContractDelegateType {
    /**开多 */
    OPEN_LONG = 1,
    /**开空 */
    OPEN_SHORT = 2,
    /**平多 */
    CLOSE_LONG = 3,
    /**平空 */
    CLOSE_SHORT = 4,
    /**减仓平多 */
    REDUCE_CLOSE_LONG = 5,
    /**减仓平空 */
    REDUCE_CLOSE_SHORT = 6,
    /**爆仓平多 */
    BURST_CLOSE_LONG = 7,
    /**爆仓平空 */
    BURST_CLOSE_SHORT = 8,
    BURST_AGREEMENT_CLOSE_LONG = 9,
    BURST_AGREEMENT_CLOSE_SHORT = 10,
    AGREEMENT_CLOSE_LONG = 11,
    AGREEMENT_CLOSE_SHORT = 12,
    BURST_CLOSE_LONG_QUERY = 13,
    BURST_CLOSE_SHORT_QUERY = 14,
    OFFSET_REDUCE_CLOSE_LONG = 19,
    OFFSET_REDUCE_CLOSE_SHORT = 20,
    BUY_IN_SINGLE_SIDE_MODE = 21, // 单向持仓 买入
    SELL_IN_SINGLE_SIDE_MODE = 22, // 单向持仓 卖出
    REDUCE_BUY_IN_SINGLE_SIDE_MODE = 23,
    REDUCE_SELL_IN_SINGLE_SIDE_MODE = 24,
    BURST_BUY_IN_SINGLE_SIDE_MODE = 25,
    BURST_SELL_IN_SINGLE_SIDE_MODE = 26,
    ADL_CLOSE_LONG = 35, //ADL平多
    ADL_CLOSE_SHORT = 36, //ADL平空
    ADL_ONE_WAY_BUY = 37, //ADL买入
    ADL_ONE_WAY_SELL = 38 //ADL卖出
}

/**
 * 混合合约保证金的持仓模式：单向、双向
 */
export enum MixContractHoldMode {
    SINGLE_SIDE_HOLD = 1, // 单向持仓
    DOUBLE_SIDE_HOLD = 2 // 双向持仓
}

/**
 * 混合合约的保证金风险模式：逐仓，全仓
 */
export enum MixContractMarginMode {
    /** 逐仓模式 */
    FIXED_MARGIN = 1,
    /** 全仓模式 */
    CROSS_MARGIN = 2
}

/**
 * 盈亏模式：开平模式，止盈止损模式
 */
export enum MixContractProfitLossMode {
    /** 开平模式 */
    OPEN_AND_CLOSE_MODE = 1,
    /** 止盈止损模式 */
    PROFIT_AND_LOSS_MODE = 2
}


/**
 * 混合合约订单状态
 */
export enum MixContractOrderStatus {
    INIT = 1, // 未撮合    未执行
    NEW = 2, // 撮合已处理  执行成功
    PARTIAL_FILL = 3, // 部分成交  执行失败
    FULL_FILL = 4, // 完全成交  取消
    CANCELLED = 5, // 撤销
    REJECT = 6 // 拒单
}

/**
 * 混合合约计划委托  止盈止损委托 状态
 */
export enum MixContractPlanOrderStatus {
    INIT = 1, //     未执行
    SUCCESS = 2, //  执行成功
    FAIL = 3, //   执行失败
    CANCELLED = 4 // 取消
}

/**
 * 混合合约的订单类型：限价 市价
 */
export enum MixContractOrderType {
    LIMIT = 0, // 限价单
    MARKET = 1, // 市价单
    PLAN = 2 // 计划委托
}

/**
 *  混合合约计划委托  触发类型  1 市场价格  2 标记价格
 */

export enum MixContractTriggerType {
    MARKET = 1,
    FAIR = 2
}

/***
 * 计划委托 执行类型  1 限价  2 闪电
 */

export enum MixContractPlanExecType {
    LIMIT = 1,
    MARKET = 2
}

/**
 * 仓位方向
 */
export enum MixContractHoldSide {
    LONG_POSITIONS = 1, // 多仓
    SHORT_POSITIONS = 2 // 空仓
}

/**
 * 仅客户端使用，委托动作：开仓，平仓
 */
export enum MixContractOrderAction {
    OPEN = 1,
    CLOSE = 2
}

export enum MixContractTimeInForceEnum {
    GTC = 0, // 普通时效
    MAKER_ONLY = 1, // 只做Maker
    IOC = 3, // 立即成交或撤销
    FOK = 2 // 完全成交或撤销
}

/**
 * 委托的交易方向，买入或者卖出
 */
export enum TradeDirection {
    Buy = 'buyer',
    Sell = 'seller'
}

// 预设委托类型
export enum PresetDelegateTypeEnum {
    TAKE_PROFIT = 1, // 止盈
    STOP_LOSS = 2 // 止损
}
/**
 * 计划委托类型
 */
export enum PlanTypeEnum {
    NORMAL = 0, // 普通计划委托
    TAKE_PROFIT = 1, // 止盈
    STOP_LOSS = 2 // 止损
}

/**
 * 计划委托的触发类型
 */
export enum PlanTriggerTypeEnum {
    MARKET_PRICE = 1, // 市场价
    FAIR_PRICE = 2 // 合理标记价格
}

export enum PlanExecTypeEnum {
    LIMIT = 1,
    MARKET = 2
}

/**
 * 根据 （开仓/平仓 + 买入/卖出） 的组合决定委托类型
 * @param action
 * @param direction
 */
export function getDelegateTypeByTradeDirection(
    action: MixContractOrderAction,
    direction: TradeDirection
) {
    return direction === TradeDirection.Buy
        ? action === MixContractOrderAction.OPEN
            ? MixContractDelegateType.OPEN_LONG // 开仓状态下，买入按钮，目标是多仓
            : MixContractDelegateType.CLOSE_SHORT // 平仓状态下，买入按钮，目标是空仓
        : action === MixContractOrderAction.OPEN
        ? MixContractDelegateType.OPEN_SHORT // 开仓状态下，卖出按钮，目标是空仓
        : MixContractDelegateType.CLOSE_LONG // 平仓状态下，卖出按钮，目标是多仓
}

/**
 * 根据 （开仓/平仓 + 多仓/空仓） 的组合决定委托类型
 * @param action
 * @param holdSide
 */
export function getDelegateTypeByHoldSide(
    action: MixContractOrderAction,
    holdSide: MixContractHoldSide,
    positionModeSet?: number
) {
    if (positionModeSet === PositionModeEnum.ONE_WAY) {
        return action === MixContractOrderAction.OPEN
            ? holdSide === MixContractHoldSide.LONG_POSITIONS
                ? MixContractDelegateType.OPEN_LONG
                : MixContractDelegateType.OPEN_SHORT
            : holdSide === MixContractHoldSide.LONG_POSITIONS
            ? MixContractDelegateType.SELL_IN_SINGLE_SIDE_MODE
            : MixContractDelegateType.BUY_IN_SINGLE_SIDE_MODE
    }
    return action === MixContractOrderAction.OPEN
        ? holdSide === MixContractHoldSide.LONG_POSITIONS
            ? MixContractDelegateType.OPEN_LONG
            : MixContractDelegateType.OPEN_SHORT
        : holdSide === MixContractHoldSide.LONG_POSITIONS
        ? MixContractDelegateType.CLOSE_LONG
        : MixContractDelegateType.CLOSE_SHORT
}

/**
 * 委托请求参数类型
 */
export interface OrderPlacerParam {
    businessLine: BusinessLineEnum // 业务线
    businessSource: BusinessSource // 业务源
    symbolId: string // 交易对ID
    orderType: OrderPriceTypeEnum // 注意注意：这个字段实际上是限价、市价
    delegateType: MixContractDelegateType // 委托类型，开多，开空，平多，平空
    timeInForceValue: MixContractTimeInForceEnum // tif
    remark: string
    delegateCount: string | number // 委托数量
    trackingNo: string // 追踪订单号
    presetTakeProfitPrice: string | number // 预设止盈价
    enterPointSource: EnterPointSource // 入口来源 WEB
    delegatePrice: string | number // 委托价格
    presetStopLossPrice: string // 预设止损价格
    tokenId: string // 使用保证金币种标识
    clientOid: string // 不明
    secondBusinessLine: string // 二级业务线，暂时不用，使用N/A即可
    planType?: PlanTypeEnum // 判断是否是计划委托，必须判断是否有该字段 计划委托 0 普通计划 1 止盈  2 止损
    triggerPrice: string // 触发价格
    triggerType: OrderTriggerTypeEnum // 触发类型 1 成交价格 2 合理标记价格
    executePrice: string //执行价格
    planExecType: PlanExecTypeEnum // 执行类型 1 限价 2 市价
    pricedSymbol?: string // 计划委托时 临时需要变量 在确认弹窗时 使用
    cancelOrder?: boolean // 平仓是否包含已委托，与用户偏好设置中"是否包含已委托"相同
    isReducePosition?: boolean // 是否只减仓
    onlyLow?: boolean // 是否只减仓
    ticketId?: string // 体验券ID

    // 以下字段为止盈止损专用字段
    presetTppTriType?: OrderTriggerTypeEnum // 预设止盈触发类型 1 成交价格 2 合理标记价格
    presetSlpTriType?: OrderTriggerTypeEnum // 预设止损触发类型 1 成交价格 2 合理标记价格
    exeTakeProfitPrice?: string // 执行止盈价格 限价
    exeStopLossPrice?: string // 执行止损价格 限价

    // 以下字段为计划委托止盈止损专用字段
    presetTPTriggerType?: OrderTriggerTypeEnum // 预设止盈触发类型 1 成交价格 2 合理标记价格
    presetSLTriggerType?: OrderTriggerTypeEnum // 预设止损触发类型 1 成交价格 2 合理标记价格
    presetTPExcutePrice?: string // 执行止盈价格 限价
    presetSLExcutePrice?: string // 执行止损价格 限价

    exeProfitBboType?: number //bbo止盈类型 66 67 68 69
    exeLossBboType?: number //bbo止损类型 70 71 72 73
    pinAes?: string //回调pin码参数
    secondSource?: number //是否是快捷下单
}

export function isOpenOrder(param: Partial<OrderPlacerParam>): boolean {
    return (
        param.delegateType === MixContractDelegateType.OPEN_LONG ||
        param.delegateType === MixContractDelegateType.OPEN_SHORT
    )
}

// 追踪委托
export interface TrackOrderPlacerParam {
    tokenId: string
    symbolId: string
    businessLine: BusinessLineEnum
    secondBusinessLine: string
    // businessSource: BusinessSource.MARKET,  // 非必传 后台自动处理
    enterPointSource: EnterPointSource

    delegateCount: string | number
    delegateType: MixContractDelegateType //委托类型 1:开多,2:开空,3:平多,4:平空 止盈止损时只有平多，平空

    pricedSymbol?: string
    planType?: number // //委托类型 0-普通计划 1-止盈计划 2-止损计划 3-移动止盈止损 4-仓位止盈 5-仓位止损 6-追踪委托

    triggerPrice: string
    triggerType: OrderTriggerTypeEnum //触发类型 1: 成交价格,   2: 合理标记价格
    rangeRate: string | number // /回调幅度
    presetTakeProfitPriceRatio: string // 预设止盈 5%
    presetStopLossPriceRatio: string // 预设止损 10%
    [key: string]: any
}

/**
 * 历史委托-执行状态
 */
export enum ExecuteStatus {
    /**未执行 */
    NotExecute = 0,
    /**执行中 */
    Executing = 1,
    /**执行成功 */
    ExecuteSuccess = 2,
    /**执行失败 */
    ExecuteFail = 3,
    /**已撤销 */
    Cancel = 4
}

/**
 * 策略类型
 */
export enum MixStrategyTypeEnum {
    GRID = 1,
    DCA = 2
}

/**
 * priceSymbol 价格币种
 */
export enum PriceSymbolEnum {
    USDT = 'USDT',
    USD = 'USD',
    USDC = 'USDC',
    SUSDT = 'SUSDT',
    SUSD = 'SUSD',
    SUSDC = 'SUSDC'
}

/**
 * 合约-业务线对应的价格币种
 */
export const BusinessLinePriceSymbolMap = {
    [BusinessLineEnum.USD_MIX_CONTRACT_BL]: PriceSymbolEnum.USD,
    [BusinessLineEnum.USDT_MIX_CONTRACT_BL]: PriceSymbolEnum.USDT,
    [BusinessLineEnum.USDC_MIX_CONTRACT_BL]: PriceSymbolEnum.USDC,
    [BusinessLineEnum.S_USD_MIX_CONTRACT_BL]: PriceSymbolEnum.SUSD,
    [BusinessLineEnum.S_USDT_MIX_CONTRACT_BL]: PriceSymbolEnum.SUSDT,
    [BusinessLineEnum.S_USDC_MIX_CONTRACT_BL]: PriceSymbolEnum.SUSDC
}

export enum MixContractTPSLTabEnum {
    position = 1,
    batch = 2,
    move = 3,
    mmr = 4
}

export enum MixContractTPSLTypeEnum {
    //0-普通计划 1-止盈计划 2-止损计划 3-移动止盈止损 4-仓位止盈 5-仓位止损 6-追踪委托 7-mmr sl
    NORMAL = 0,
    TAKE_PROFIT = 1,
    STOP_LOSS = 2,
    MOVE_TPSL = 3,
    POSITION_TP = 4,
    POSITION_SL = 5,
    TRACK = 6,
    MMR_SL = 7
}
